module.exports = __webpack_public_path__ + "assets/img/20@3x.323ec8c9.png";